// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import SideColumnLayoutComponent from "@store/Library/Components/Toolkit/Layout/SideColumnLayout";
import React, { FC } from "react";

const enum fields {
    showSideColumnOnMobile = "showSideColumnOnMobile",
}

export interface SideColumnLayoutProps extends WidgetProps {
    fields: {
        [fields.showSideColumnOnMobile]?: boolean;
    };
}

const SideColumnLayout: FC<SideColumnLayoutProps> = ({ id, fields: { showSideColumnOnMobile } }) => {
    return <SideColumnLayoutComponent id={id} showSideColumnOnMobile={showSideColumnOnMobile} />;
};

const widgetModule: WidgetModule = {
    component: SideColumnLayout,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Side Column Layout",
        icon: "table-layout",
        fieldDefinitions: [
            {
                name: fields.showSideColumnOnMobile,
                displayName: "Show side column content on mobile",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
    },
};

export default widgetModule;
